import { Link } from 'react-router-dom';
import { featuredVideos } from '@/mocks/home';

export default function HeroSection() {
  const mainVideo = featuredVideos[5];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src={mainVideo.cover}
        alt={mainVideo.title}
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>

      <div className="absolute inset-0 flex items-end md:items-center">
        <div className="w-full px-4 md:px-6 pb-10 md:pb-0">
          <div className="max-w-3xl">
            <div className="flex items-center gap-2 mb-3">
              <span className="px-2.5 py-0.5 text-xs rounded-full bg-primary-500 text-white whitespace-nowrap">热播中</span>
              <span className="px-2.5 py-0.5 text-xs rounded-full bg-accent-500 text-white whitespace-nowrap">新上线</span>
            </div>
            <h1 className="text-2xl md:text-5xl font-bold font-heading text-white mb-3">
              {mainVideo.title}
            </h1>
            <p className="text-sm md:text-base text-white/80 line-clamp-2 max-w-xl mb-4">
              {mainVideo.description}
            </p>
            <div className="flex items-center gap-4 text-xs md:text-sm text-white/70 mb-5">
              <span className="flex items-center gap-1">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-star-fill text-accent-500"></i>
                </div>
                {mainVideo.rating}
              </span>
              <span>{mainVideo.duration}</span>
              <span>{mainVideo.views.toLocaleString()}次播放</span>
            </div>
            <div className="flex items-center gap-3">
              <Link
                to={`/article/${mainVideo.id}`}
                className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-play-fill"></i>
                  </div>
                  立即观看
                </div>
              </Link>
              <Link
                to={`/category/${mainVideo.categorySlug}`}
                className="px-5 py-2.5 border border-white/30 hover:border-white/60 text-white text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                更多{mainVideo.category}
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-4 right-4 md:right-6 hidden md:flex items-center gap-2">
        {[0, 1, 2, 3, 4].map((i) => (
          <button
            key={i}
            className={`w-2 h-2 rounded-full transition-all duration-200 cursor-pointer ${
              i === 0 ? 'bg-primary-500 w-6' : 'bg-white/50 hover:bg-white/80'
            }`}
            aria-label={`轮播图 ${i + 1}`}
          ></button>
        ))}
      </div>
    </section>
  );
}